var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState, useEffect } from "react";
import "./ProfileHistory.scss";
import useCalculateZoom from "@frameworks/web/utils/useCalculateZoom";
import { getArnViewHistorySummaryDetails, } from "@frameworks/arn-transfer/api/ArnViewHistorySummary";
import { getArnViewHistoryDetails, } from "@frameworks/arn-transfer/api/ArnViewHistoryDetails";
import GenericTableShimmer from "@frameworks/shared-library/components/GenericTableShimmer/GenericTableShimmer";
import DynamicPagination from "@frameworks/shared-library/components/Pagination/Pagination";
import GenericTable from "@frameworks/shared-library/components/GenericTable";
import Errormsg from "@frameworks/shared-library/components/errorMsg";
import noResultsFound from "@frameworks/shared-library/assets/images/markets/noResultsFound.svg";
import ViewHistorySummary from "./ViewHistorySummary";
import ViewHistoryProfileDetails from "./ViewHistoryProfileDetails";
import moment from "moment";
import { ESortOrder } from "@domains/features/Markets/MutualFunds/dto/MutualFundsSchemesDTO";
import GenericSidebar from "@frameworks/shared-library/components/GenericSidebar";
import SidebarHeader from "../Sidebar/SidebarHeader";
import MFCentralSidebarBody from "../Sidebar/MFCentralSidebarBody";
import MFCentralSidebarFooter from "../Sidebar/MFCentralSidebarFooter";
import { Overlay, Popover } from "react-bootstrap";
import { EScreenState, syncNowCheckBoxDetails, } from "@frameworks/arn-transfer/constants/constant";
import { getMfCenterOtp, } from "@frameworks/arn-transfer/api/MfCenterOtp";
import { getMfCenterData } from "@frameworks/arn-transfer/api/MfCenterData";
import RadioButton from "@frameworks/shared-library/components/RadioButton/RadioButton";
import { useLocation, useNavigate } from "react-router-dom";
var ProfileHistory = function () {
    var navigate = useNavigate();
    var state = useLocation().state;
    var zoom = useCalculateZoom();
    var _a = __read(useState(false), 2), tableLoader = _a[0], setTableLoader = _a[1];
    var _b = __read(useState([]), 2), tableData = _b[0], setTableData = _b[1];
    var _c = __read(useState(false), 2), openSidebar = _c[0], setOpenSidebar = _c[1];
    var _d = __read(useState({ type: ESortOrder.DESCENDING, sortKey: "ac_name" }), 2), sortType = _d[0], setSortType = _d[1];
    var _e = __read(useState(), 2), viewHistorySummaryData = _e[0], setViewHistorySummaryData = _e[1];
    console.log(tableData);
    var _f = __read(useState(state === null || state === void 0 ? void 0 : state.selectedDetails), 2), clientInfoToBeSynced = _f[0], setClientInfoToBeSynced = _f[1];
    var _g = __read(useState(""), 2), mobileNumber = _g[0], setMobileNumber = _g[1];
    var _h = __read(useState(false), 2), isShowOtpField = _h[0], setIsShowOtpField = _h[1];
    var _j = __read(useState(false), 2), otpTimer = _j[0], setOtpTimer = _j[1];
    var _k = __read(useState(""), 2), otp = _k[0], setOtp = _k[1];
    var _l = __read(useState(""), 2), isOtpError = _l[0], setIsOtpError = _l[1];
    var _m = __read(useState(false), 2), isReadyToProceed = _m[0], setIsReadyToProceed = _m[1];
    var _o = __read(useState(""), 2), mobileFieldError = _o[0], setMobileFieldError = _o[1];
    var _p = __read(useState(EScreenState.GENERATE_OTP), 2), currentScreen = _p[0], setCurrentScreen = _p[1];
    var _q = __read(useState(""), 2), seletedCheckBox = _q[0], setSeletedCheckBox = _q[1];
    var _r = __read(useState(), 2), genereateOtpData = _r[0], setGenereateOtpData = _r[1];
    var _s = __read(useState(false), 2), sidebarBodyLoader = _s[0], setSidebarBodyLoader = _s[1];
    var _t = __read(useState(false), 2), inputDisabled = _t[0], setInputDisabled = _t[1];
    var _u = __read(useState({ isShowPopup: false, containerId: "", pan: "" }), 2), tableSyncActionConfig = _u[0], setTableSyncActionConfig = _u[1];
    var getArnViewHistorySummaryData = function () {
        var _a;
        var payload = {
            uccCode: (_a = state === null || state === void 0 ? void 0 : state.selectedDetails) === null || _a === void 0 ? void 0 : _a.ucccode,
        };
        getArnViewHistorySummaryDetails(payload)
            .then(function (resp) {
            setViewHistorySummaryData(resp.data);
        })
            .catch(function (err) { });
    };
    var handleCallbackSort = function (e) {
        getArnViewHistoryDetailsData({ orderby: e.sortKey, orderbydesc: !e.type });
        setSortType(function () { return ({
            type: e.type ? ESortOrder.ASCENDING : ESortOrder.DESCENDING,
            sortKey: e.sortKey,
        }); });
    };
    var getArnViewHistoryDetailsData = function (params) {
        var _a;
        setTableLoader(true);
        var payload = {
            uccCode: (_a = state === null || state === void 0 ? void 0 : state.selectedDetails) === null || _a === void 0 ? void 0 : _a.ucccode,
            page_index: params === null || params === void 0 ? void 0 : params.page_index,
            page_size: params === null || params === void 0 ? void 0 : params.page_size,
            orderbydesc: !!(params === null || params === void 0 ? void 0 : params.orderbydesc),
            orderby: "sync_id",
        };
        getArnViewHistoryDetails(payload)
            .then(function (resp) {
            setTableData(resp.data);
            setTableLoader(false);
        })
            .catch(function (err) {
            setTableLoader(true);
        });
    };
    var profileHistoryColumn = [
        {
            columnName: "Uploaded On",
            key: "updated_on",
            sortKey: "updated_on",
            arrows: true,
            applySorting: true,
            arrowClassName: "justify-content-end",
            tdCustomFunction: function (value) {
                var formattedDate = moment(value).format("DD MMM YYYY h:mm A");
                return (React.createElement("div", { className: "DMSan_14_500 txt-darkSapphire" }, formattedDate ? formattedDate : "-"));
            },
        },
        {
            columnName: "Source",
            key: "source",
            sortKey: "source",
            arrows: true,
            applySorting: true,
            arrowClassName: "justify-content-end",
            tdCustomFunction: function (value) {
                return (React.createElement("div", { className: "d-flex" },
                    React.createElement("div", { className: "DMSansNormal_12_400 tags" }, value ? value : "-")));
            },
        },
        {
            columnName: "Mobile Number",
            key: "mobileno",
            sortKey: "mobileno",
            arrows: false,
            applySorting: false,
            arrowClassName: "justify-content-end",
            tdCustomFunction: function (value) {
                return (React.createElement("div", { className: "DMSanN_14_400 txt-purpleFog" }, value ? value : "-"));
            },
        },
        {
            columnName: "Status",
            key: "status",
            sortKey: "status",
            arrows: true,
            applySorting: true,
            arrowClassName: "justify-content-end",
            tdCustomFunction: function (value) {
                return (React.createElement("div", { className: "constent-text DMSanN_14_400 ".concat(value === "Completed"
                        ? "txt_green"
                        : value === "Consent Expired"
                            ? "txt_bloodRed "
                            : "txt-dark-orange") },
                    React.createElement("span", { className: value === "Completed"
                            ? "bg_green"
                            : value === "Consent Expired"
                                ? "bg_bloodRed"
                                : "bg-dark-orange" }),
                    value));
            },
        },
        {
            columnName: "Actions",
            key: "actions",
            sortKey: "action",
            arrows: false,
            applySorting: false,
            arrowClassName: "justify-content-end",
            keysForCustomFunction: ["status", "action"],
            tdCustomFunction: function (key) {
                return key[0] == "Completed" || key[1] == "" ? null : (React.createElement("button", { className: "DMSanM_14_500 resend-consent-btn", onClick: function (e) {
                        setOpenSidebar(true);
                    } }, key[1]));
            },
        },
    ];
    var handleActionClick = function () {
        navigate("/dashboard/mf-transfer/transfer-in?details=".concat(btoa(JSON.stringify(viewHistorySummaryData))), { replace: true });
    };
    var getMfCenterOtpData = function () {
        setInputDisabled(true);
        setSidebarBodyLoader(true);
        getMfCenterOtp({
            uccCode: clientInfoToBeSynced === null || clientInfoToBeSynced === void 0 ? void 0 : clientInfoToBeSynced.ucccode,
            syncId: clientInfoToBeSynced === null || clientInfoToBeSynced === void 0 ? void 0 : clientInfoToBeSynced.sync_id,
            email: clientInfoToBeSynced === null || clientInfoToBeSynced === void 0 ? void 0 : clientInfoToBeSynced.email,
            pan: clientInfoToBeSynced === null || clientInfoToBeSynced === void 0 ? void 0 : clientInfoToBeSynced.pan,
            mobile: clientInfoToBeSynced === null || clientInfoToBeSynced === void 0 ? void 0 : clientInfoToBeSynced.mobileno,
        })
            .then(function (resp) {
            if (resp === null || resp === void 0 ? void 0 : resp.data) {
                setGenereateOtpData(resp === null || resp === void 0 ? void 0 : resp.data);
                setIsShowOtpField(true);
                setOtpTimer(true);
                setMobileFieldError("");
                setInputDisabled(true);
            }
            setSidebarBodyLoader(false);
        })
            .catch(function (err) {
            setSidebarBodyLoader(false);
        });
    };
    var getMfCenterDataToProcced = function () {
        setSidebarBodyLoader(true);
        getMfCenterData({
            id: genereateOtpData === null || genereateOtpData === void 0 ? void 0 : genereateOtpData.id,
            reqId: genereateOtpData === null || genereateOtpData === void 0 ? void 0 : genereateOtpData.reqId,
            otpRef: genereateOtpData === null || genereateOtpData === void 0 ? void 0 : genereateOtpData.otpRef,
            userSubjectReference: genereateOtpData === null || genereateOtpData === void 0 ? void 0 : genereateOtpData.userSubjectReference,
            clientRefNo: genereateOtpData === null || genereateOtpData === void 0 ? void 0 : genereateOtpData.clientRefNo,
            enteredOtp: otp,
            uccCode: clientInfoToBeSynced === null || clientInfoToBeSynced === void 0 ? void 0 : clientInfoToBeSynced.ucccode,
        })
            .then(function (resp) {
            var _a, _b, _c, _d, _e;
            if ((resp === null || resp === void 0 ? void 0 : resp.data) && ((_a = resp === null || resp === void 0 ? void 0 : resp.data) === null || _a === void 0 ? void 0 : _a.isSuccess))
                setCurrentScreen(EScreenState.SYNC_SUCCESS);
            else if (((_c = (_b = resp === null || resp === void 0 ? void 0 : resp.errors) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.code) === "406") {
                setIsOtpError((_e = (_d = resp === null || resp === void 0 ? void 0 : resp.errors) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.message);
                setIsReadyToProceed(false);
            }
            else
                setCurrentScreen(EScreenState.SYNC_FAILURE);
            setSidebarBodyLoader(false);
        })
            .catch(function (error) {
            setMobileFieldError("Invalid PAN/PEKRN, Mobile/Email combination");
            setCurrentScreen(EScreenState.SYNC_FAILURE);
            setSidebarBodyLoader(false);
        });
    };
    var handlePopupOpen = function () {
        setTableSyncActionConfig(function (prev) { return (__assign(__assign({}, prev), { isShowPopup: true })); });
    };
    useEffect(function () {
        getArnViewHistorySummaryData();
        getArnViewHistoryDetailsData();
    }, []);
    useEffect(function () {
        var _a;
        if (state === null || state === void 0 ? void 0 : state.selectedDetails) {
            setMobileNumber((_a = state === null || state === void 0 ? void 0 : state.selectedDetails) === null || _a === void 0 ? void 0 : _a.mobileno);
            setClientInfoToBeSynced(state === null || state === void 0 ? void 0 : state.selectedDetails);
        }
    }, [state === null || state === void 0 ? void 0 : state.selectedDetails]);
    var formattedLastSyncDate = moment(clientInfoToBeSynced === null || clientInfoToBeSynced === void 0 ? void 0 : clientInfoToBeSynced.last_sync_date).format("MMMM YYYY");
    return (React.createElement("div", { className: "profile-history-container", style: { zoom: zoom } },
        viewHistorySummaryData && (React.createElement(ViewHistoryProfileDetails, { data: viewHistorySummaryData })),
        React.createElement(ViewHistorySummary, { data: viewHistorySummaryData, tableSyncActionConfig: tableSyncActionConfig, id: "initiate-mf-center", handlePopupOpen: handlePopupOpen, handleTransferIn: handleActionClick }),
        React.createElement("div", { className: "body-section" },
            React.createElement("div", { className: "DMSansBold_20_700 mb-4" }, "Sync History"),
            tableLoader && (React.createElement(GenericTableShimmer, { rowCount: 10, columnCount: 6, columnsWidthClass: "table-shimmer-col-fr2-1-1-1-2" })),
            (tableData === null || tableData === void 0 ? void 0 : tableData.length) > 0 ? (React.createElement(DynamicPagination, { dataLengthPerPage: 10, data: tableData, Bodycomponent: GenericTable, rowClassName: "", columns: profileHistoryColumn, parentClassName: "mf-folios-transfer-in-table", infinityScroll: true, sortIconUp: "edel-icon-arrow-up-thin", sortIconDown: "edel-icon-arrow-down", viewAll: true, isPageFromParent: true, selectedSortVal: sortType.type, selectedSortColumnVal: sortType.sortKey, callbackSorted: function (e) {
                    handleCallbackSort(e);
                } })) : (React.createElement("div", { className: "custom-error-state" },
                React.createElement(Errormsg, { image: noResultsFound, msg: "No Data Found" }))),
            openSidebar && (React.createElement(GenericSidebar, { parentClassname: "arn-transfer-all-client-sidebar", blurBackground: true, header: React.createElement(SidebarHeader, { title: "MF Central", description: "Sync MF holdings. Client OTP required.", iconClass: "edel-icon-cloud" }), body: React.createElement(MFCentralSidebarBody, { mobileNumber: mobileNumber, setMobileNumber: function () { var _a; return setMobileNumber((_a = state === null || state === void 0 ? void 0 : state.selectedDetails) === null || _a === void 0 ? void 0 : _a.mobileno); }, isShowOtpField: isShowOtpField, setIsShowOtpField: setIsShowOtpField, otp: otp, setOtp: setOtp, otpTimer: otpTimer, setOtpTimer: setOtpTimer, isOtpError: isOtpError, setIsOtpError: setIsOtpError, currentScreen: currentScreen, setCurrentScreen: setCurrentScreen, isReadyToProceed: isReadyToProceed, setIsReadyToProceed: setIsReadyToProceed, clientInfoToBeSynced: state === null || state === void 0 ? void 0 : state.selectedDetails, getMfCenterOtpData: getMfCenterOtpData, sidebarBodyLoader: sidebarBodyLoader, inputDisabled: inputDisabled, mobileFieldError: mobileFieldError }), footer: React.createElement(MFCentralSidebarFooter, { isReadyToProceed: isReadyToProceed, setIsReadyToProceed: setIsReadyToProceed, currentScreen: currentScreen, setCurrentScreen: setCurrentScreen, setOpenSidebar: setOpenSidebar, getMfCenterDataToProcced: getMfCenterDataToProcced, setOtpTimer: setOtpTimer, setIsShowOtpField: setIsShowOtpField, setInputDisabled: setInputDisabled, clientInfoToBeSynced: state === null || state === void 0 ? void 0 : state.selectedDetails, setIsOtpError: setIsOtpError }), openKey: openSidebar, setOpenKey: function (e) {
                    if (e === false) {
                        setOpenSidebar(e);
                        setIsOtpError("");
                    }
                }, arrowClose: true, delay: 10, dontCloseOnOutsideClick: true })),
            (tableSyncActionConfig === null || tableSyncActionConfig === void 0 ? void 0 : tableSyncActionConfig.isShowPopup) && (React.createElement(Overlay, { onHide: function (e) {
                    setTableSyncActionConfig(function (prev) { return (__assign(__assign({}, prev), { isShowPopup: false })); });
                    setSeletedCheckBox("");
                }, show: true, target: document.getElementById("initiate-mf-center"), rootClose: true, rootCloseEvent: "click", placement: "bottom-end", container: document.getElementById("initiate-mf-center") },
                React.createElement(Popover, { id: "popover-contained", className: "sync-now-popup removePopupTooltipArrow", style: { position: "fixed" } },
                    React.createElement(Popover.Body, null, syncNowCheckBoxDetails === null || syncNowCheckBoxDetails === void 0 ? void 0 : syncNowCheckBoxDetails.map(function (val, idx) {
                        var _a, _b;
                        return (React.createElement("div", { className: "d-flex gap-2 single-sync ".concat(((_a = val === null || val === void 0 ? void 0 : val.item) === null || _a === void 0 ? void 0 : _a.value) === seletedCheckBox &&
                                "bg-ghost-white3"), key: idx, onClick: function () {
                                var _a;
                                setSeletedCheckBox((_a = val === null || val === void 0 ? void 0 : val.item) === null || _a === void 0 ? void 0 : _a.value);
                                setOpenSidebar(true);
                            } },
                            React.createElement("div", null,
                                React.createElement(RadioButton, { name: "sync-now-radio", list: val === null || val === void 0 ? void 0 : val.item, key: idx, selected: seletedCheckBox, onChange: function (e) {
                                        setSeletedCheckBox(e.target.value);
                                        setOpenSidebar(true);
                                    } })),
                            React.createElement("div", { className: "d-flex flex-column gap-2" },
                                React.createElement("span", { className: "DMSanN_14_400 txt-purpleFog" }, (_b = val === null || val === void 0 ? void 0 : val.item) === null || _b === void 0 ? void 0 : _b.display),
                                React.createElement("span", { className: "DMsanR_12_300 txt_manatee" }, val === null || val === void 0 ? void 0 : val.desc),
                                React.createElement("span", { className: "DMsanR_10_400 txt_secondary-gray" },
                                    React.createElement("i", { className: "edel-icon-refresh-stroke me-1" }),
                                    "Last synced: ",
                                    formattedLastSyncDate))));
                    }))))))));
};
export default ProfileHistory;
